import { render, staticRenderFns } from "./NumeratoriViewComponent.vue?vue&type=template&id=0be4e2a3&scoped=true"
import script from "./NumeratoriViewComponent.vue?vue&type=script&lang=js"
export * from "./NumeratoriViewComponent.vue?vue&type=script&lang=js"
import style0 from "./NumeratoriViewComponent.vue?vue&type=style&index=0&id=0be4e2a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be4e2a3",
  null
  
)

export default component.exports